import * as React from "react";

const useIsMobile = (): boolean => {
  const [windowWidth, setWindowWidth] = React.useState<null | number>(null);

  const handleResize = () => {
    setWindowWidth(window.innerWidth);
  };

  React.useEffect(() => {
    window.addEventListener("resize", handleResize);

    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowWidth !== null && windowWidth < 1024;
};

export default useIsMobile;
